import React from 'react';
import {
  ButtonPrimary,
  ButtonSecondary,
  createBasicColorSet,
} from '@spotify-internal/encore-web';
import { purify } from '../../lib/purify';

type ButtonPropTypes = React.ComponentProps<typeof ButtonPrimary> & {
  children?: string;
  href?: string;
  label?: string;
  backgroundColor?: string;
  borderValues?: {
    color: string;
    width: number;
  };
  border?: string;
  dataEventCategory?: string;
  dataEventAction?: string;
  dataEventLabel?: string;
  insertMarket?: boolean;
};

function ButtonComponent(props: ButtonPropTypes) {
  const {
    backgroundColor = '#000',
    color,
    children,
    label,
    href,
    dataEventAction,
    dataEventCategory,
    dataEventLabel,
    border,
    name,
    insertMarket: _insertMarket,
    ...rest
  } = props;

  return (
    <div>
      {border ? (
        <ButtonSecondary
          aria-label={label}
          data-event-category={dataEventCategory}
          data-event-action={dataEventAction}
          data-event-label={dataEventLabel}
          href={href}
          tabIndex={0}
          {...rest}
        >
          {children && (
            <span dangerouslySetInnerHTML={{ __html: purify(children) }} />
          )}
        </ButtonSecondary>
      ) : (
        <ButtonPrimary
          UNSAFE_colorSet={createBasicColorSet(backgroundColor, color)}
          aria-label={label}
          data-event-category={dataEventCategory}
          data-event-action={dataEventAction}
          data-event-label={dataEventLabel}
          href={href}
          tabIndex={0}
          name={name}
          {...rest}
        >
          {children && (
            <span dangerouslySetInnerHTML={{ __html: purify(children) }} />
          )}
        </ButtonPrimary>
      )}
    </div>
  );
}

export default ButtonComponent;
